import Image from 'next/image';
import Link from 'next/link';

export function SiteFooter() {
  return (
    <footer className="py-20 bg-white border-t border-warm-gray-200">
      <div className="max-w-[1400px] mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-[2fr_1fr_1fr_1.5fr] gap-12 lg:gap-16 mb-16">
          {/* Brand column */}
          <div>
            <Link href="/" className="flex items-center gap-3 no-underline mb-6 group">
              <Image src="/logo.svg" alt="" width={44} height={44} className="group-hover:scale-105 transition-transform" />
              <span className="font-display text-2xl font-medium text-navy tracking-tight">TrusteeKit</span>
            </Link>
            <p className="text-warm-gray-600 text-sm leading-relaxed max-w-[280px] font-serif">
              Gift Aid automation and donation processing for small UK charities.
            </p>
          </div>

          {/* Links columns */}
          <div>
            <h4 className="text-xs font-bold tracking-widest uppercase text-warm-gray-500 mb-5">Product</h4>
            <ul className="space-y-3">
              <li><Link href="/#features" className="text-warm-gray-600 hover:text-trust-blue transition-colors text-sm">Features</Link></li>
              <li><Link href="/#pricing" className="text-warm-gray-600 hover:text-trust-blue transition-colors text-sm">Pricing</Link></li>
              <li><Link href="/why-direct-debit" className="text-warm-gray-600 hover:text-trust-blue transition-colors text-sm">Why Direct Debit</Link></li>
              <li><Link href="/signup" className="text-warm-gray-600 hover:text-trust-blue transition-colors text-sm">Sign up</Link></li>
              <li><Link href="/login" className="text-warm-gray-600 hover:text-trust-blue transition-colors text-sm">Sign in</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-xs font-bold tracking-widest uppercase text-warm-gray-500 mb-5">Company</h4>
            <ul className="space-y-3">
              <li><Link href="/#about" className="text-warm-gray-600 hover:text-trust-blue transition-colors text-sm">About</Link></li>
              <li><a href="mailto:%22TrusteeKit%20Help%22%20%3Cinfo%40trusteekit.co.uk%3E?subject=Help%20with%20TrusteeKit" className="text-warm-gray-600 hover:text-trust-blue transition-colors text-sm">Contact</a></li>
            </ul>
          </div>

          {/* Get started */}
          <div>
            <h4 className="text-xs font-bold tracking-widest uppercase text-warm-gray-500 mb-5">Get Started</h4>
            <p className="text-warm-gray-600 text-sm mb-4">Free to sign up. Pay only when donations come in.</p>
            <Link
              href="/signup"
              className="inline-flex items-center gap-2 text-trust-blue-700 hover:text-trust-blue-800 font-medium text-sm transition-colors group"
            >
              Create your account
              <svg className="w-4 h-4 group-hover:translate-x-1 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 8l4 4m0 0l-4 4m4-4H3" />
              </svg>
            </Link>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="pt-8 border-t border-warm-gray-200 flex flex-wrap justify-between items-center gap-4">
          <p className="text-sm text-warm-gray-500">
            &copy; 2026 TrusteeKit. HMRC Vendor ID 9268.
          </p>
          <div className="flex gap-8">
            <Link href="/privacy" className="text-sm text-warm-gray-500 hover:text-trust-blue transition-colors">Privacy</Link>
            <Link href="/terms" className="text-sm text-warm-gray-500 hover:text-trust-blue transition-colors">Terms</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
